// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"styles_contenedor__s2Cpe","icono":"styles_icono__sbkRL","mensaje":"styles_mensaje__g5I6Y"};